// extracted by mini-css-extract-plugin
module.exports = {"toggleContainer":"toggleContainer_HIDYe","hamburgerIcon":"hamburgerIcon_YtSFu","clicked":"clicked_1BFQX","top":"top_Bw8xk","bottom":"bottom_jGuBq","middle":"middle_1AeQf"};